<template>
  <div v-if="!isLoading" class="active-courses">
    <h5 class="active-courses__header dashboard__tab-sub-title">
      Active courses
    </h5>
    <h6
      class="active-courses__header active-courses__no-courses"
      v-if="!activeCourses.length"
    >
      You don't have any active courses
    </h6>
    <ActiveCourseTile
      v-for="course in activeCourses"
      :key="course.id"
      :course="course"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActiveCourseTile from '@/components/user-dashboard/learning/ActiveCourseTile.vue'

export default {
  name: 'ActiveCourses',
  components: {
    ActiveCourseTile,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      activeCourses: state => state.courses.activeCourses,
    }),
  },
  methods: {
    async removeActiveCourse(course) {
      // eslint-disable-next-line
      if (confirm('Are you sure you want to remove this active course?')) {
        await this.$store.dispatch('courses/removeActiveCourse', course.id)
        await this.$store.dispatch('courses/getActiveCourses')
        this.sendMixpanelEvent(
          this.eventsConstants.CONTENT_COURSE_ACTIVE_REMOVED,
          {
            course_id: course.id,
            course_name: course.name,
            trigger: 'userDashboard',
            ...course,
          }
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.active-courses {
  margin: 50px 0;
  &__header {
    display: flex;
  }
  &__course {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    @include mobile {
      padding: 20px 0px;
    }
    &--title {
      color: var(--white);
      font-size: 1rem;
      width: 100%;
      padding: 0 25px 15px 0;
      @include mobile {
        width: 50%;
        padding: 0 25px 0 0;
      }
    }
    &--instructor {
      display: none;
      @include mobile {
        display: block;
        color: var(--white);
        width: 25%;
      }
    }
    &--remove {
      width: 12.5%;
      &--icon {
        color: var(--white);
        font-size: (24 / 16) * 1rem;
        border: none;
        background: none;
        cursor: pointer;
        transition: color 0.2s ease-out;
        &:hover {
          color: var(--red);
        }
      }
    }
    &--link-container {
      display: flex;
      align-items: center;
      width: auto;
      @include tablet {
        width: 12.5%;
      }
    }
  }
  &__no-courses {
    font-size: rem(18);
    line-height: 24px;
    margin: 0;
    color: var(--white);
  }
}
</style>
